import { gql } from "@apollo/client";
import CreateConfigItemDialog from "./CreateConfigItemDialog";

const CREATE_VISIT_TYPE = gql(`
  mutation CreateVisitType(
    $name: String!
  )
  @permission(requires: manageOrgConfig)
  {
    createVisitType(
      name: $name
    ) {
      id
      name
    }
  }
`);

type CreateVisitTypeDialogProps = {
  open: boolean;
  onClose: () => void;
};

const CreateVisitTypeDialog = ({ open, onClose }: CreateVisitTypeDialogProps) => {
  return (
    <CreateConfigItemDialog
      open={open}
      onClose={onClose}
      title="Create Visit Type"
      mutation={CREATE_VISIT_TYPE}
      mutationName="createVisitType"
      redirectPath="/operate-config/visit-types"
    />
  );
};

export default CreateVisitTypeDialog;
